
<template>
    <v-main>
        
        <navBar title="Ares - Sales partners" :home="true" type="inpt"/>

        <v-container fluid>  
            <v-card flat>
                <v-row dense class="ml-6 flex-row">
                    <h2>Sales partners</h2>
                    <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail class="search-field"/>
                    <inpt_type_select ref="inpttype" label="Sales partner type" :dense="false" function="filter" :value="inpt_type" field="inpt_type" @updateData="updateData" class="filter-field"/> 
                    <inpt_status_select ref="inptstatus" label="Sales partner status" :dense="false" function="filter" :value="inpt_status" field="inpt_status" @updateData="updateData" class="filter-field"/> 
                    <div>Found {{ filteredInpt.length }} partners</div>
                </v-row>
                <v-card-text>

                    <v-data-table flat dense hide-default-footer fixed-header
                                :headers="getTableHeaders()" 
                                :must-sort=true 
                                :items="filteredInpt"
                                :search="search"
                                :disable-pagination=true   
                                :height="wInnerHeight-185"
                                item-key="inpt_code"
                                no-data-text="No data available" class="table-font"> 

                        <template v-slot:item="inpt">
                            <tr  @click="$router.open('/task/inpt/onInpt/' + inpt.item.inpt_encrid)">
                                <td>{{inpt.item.inpt_code}}</td>
                                <td style = "display:flex; align-items: center"><img contain :src="inpt.item.inpt_img" height="20px"></td>
                                <td>{{inpt.item.inpt_naam}}</td> 
                                <!-- <td align="center"><span v-if="inpt.item.iperNumberOfErrors!==''"><v-avatar size="21" class="a-error"> {{ inpt.item.iperNumberOfErrors }} </v-avatar></span></td> -->
                                <!-- <td align="center"><span v-if="inpt.item.iperNumberOfWarnings!==''"><v-avatar size="21" class="a-warning"> {{ inpt.item.iperNumberOfWarnings }} </v-avatar></span></td>      -->                                
                                <td>{{inpt.item.inpt_fact}}</td>               
                                <td>{{inpt.item.inpt_prijs_verhoging}}</td>                 
                                <td>{{$refs.inpttype.getDescription(inpt.item.inpt_type)}}</td>      
                                <td>{{$refs.inptstatus.getDescription(inpt.item.inpt_status)}}</td>          
                            </tr>
                        </template>                                               

                    </v-data-table>

                </v-card-text>                
            </v-card>  
        </v-container>
    </v-main>
</template>


<script>

import mxscreensize from '@/components/js/screensize';
import navBar from "@/components/ui/navbars/navbar.vue";
import inpt_type_select from '@/components/task/inpt/ui/inpt_type_select.vue';
import inpt_status_select from '@/components/task/inpt/ui/inpt_status_select.vue';

export default {
    components: {
        navBar,
        inpt_type_select,
        inpt_status_select
    },
    computed:{
        filteredInpt: function(){
            let filter1 = this.searchInpt.filter(inpt => this.inpt_type===null || inpt.inpt_type===this.inpt_type ? true : false)
            let filter2 = filter1.filter(inpt => this.inpt_status===null || inpt.inpt_status===this.inpt_status ? true : false)
            return filter2
        }
    },
    mixins: [mxscreensize],
    data() {
        return {
            searchInpt: [],
            search: '',
            inpt_type: null,
            inpt_status: 'Actief',
        }
    },        
    mounted() {
        this.$axios
            .post("ares/json/ares/task/inpt/searchInpt.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "searchInpt"
                },
                searchInpt: {
                }
            })
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.searchInpt = res.data.searchInpt;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    },
    methods: {
        updateData(data) {
            this[data.field] = data.value;
        },            
        getTableHeaders() {
            return [
                { text: "Id", value: "inpt_code", sortable: true, width: "1%" },
                { text: "Logo", value: "inpt_img", sortable: false },
                { text: "Name", align: "left", sortable: true, value: "inpt_naam" },
                { text: "Com. invoice", align: "left", sortable: false, value: "inpt_fact" },
                { text: "Raise", value: "inpt_prijs_verhoging", sortable: false },
                { text: "Type", value: "inpt_type", sortable: true },
                { text: "Status", value: "inpt_status", sortable: true },
            ];
        },
    }
};

</script> 

<style scoped>

  .flex-row {
      display: flex;
      column-gap: 2em;
      align-items: center;
  }
  .search-field{
      max-width: 400px;
  } 
  .filter-field{
      max-width: 250px;
  }    
  .a-error {
    background: transparent !important;
    font-size: 12px !important;
    font-weight: 600 !important;    
    border: 2px solid red;
    color: red;
    cursor:default;
  }
  .a-warning {
    background: transparent !important;
    font-size: 12px !important;
    font-weight: 600 !important;    
    border: 2px solid orange;
    color: orange;
    cursor:default;
  }  

</style>